import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { updateSelectedServices } from "../../../redux/features/calculatorSlice";
import { getWorkServicesByTypeWithCompany } from "../../../utils";
import { LoaderAnimationComponent } from "../../common/LoaderAnimationComponent";
import { JobFormServices } from "../../jobs2/JobFormServices";

export const CommercialServices = ({ sx, showError }) => {
  const { selectedServices } = useSelector((state) => state.calculatorState.calculator?.commercial);
  const { company } = useSelector((state) => state.userState);
  const [serviceList, setServiceList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const token = sessionStorage.getItem("token");

  useEffect(() => {
    setIsLoading(true);
    getWorkServicesByTypeWithCompany(token, company?.id, "commercial")
      .then((data) => {
        let services = [];
        data.forEach((service) => {
          if (service?.companyServices?.some((cs) => cs.isActive)) {
            services.push(service);
          }
        });
        setServiceList(services);
      })
      .finally(
        setTimeout(() => {
          setIsLoading(false);
        }, 500)
      );
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        mb: 2,
      }}
    >
      <Box sx={{ width: "100%" }}>
        <JobFormServices data={serviceList} switchState={selectedServices} storeAction={updateSelectedServices}></JobFormServices>
      </Box>

      {/* {showError && selectedServices?.length === 0 && (
        <Typography component="span" sx={{ color: "error.main", mt: 2, textAlign: "center" }}>
          Please select at least one service.
        </Typography>
      )} */}
      <LoaderAnimationComponent open={isLoading}></LoaderAnimationComponent>
    </Box>
  );
};
